import React, { useState } from 'react';
import { IUseEarlyAccessResults } from '@pro/activity/testerClub/useEarlyAccessResults';
import { useTrans } from 'base/utils/i18n';
import styles from './index.module.less';
import cn from 'classnames';
import Iconfont from '@base/lib/Iconfont';

type IProps = {
    results: IUseEarlyAccessResults
}

const ListDefaultLen = 10

const ResultsSelected: React.FC<IProps> = (props) => {
    const { t } = useTrans();
    const { results } = props;
    const { resultsData } = results;

    const { emails = [] } = resultsData || {}

    const [showMore, setShowMore] = useState<boolean>(false)

    return (
        <div className={styles['selected-wrap']}>
            <h3 className={styles.title}>{t('web_shop_activity_early_access_selected')}</h3>

            <div className={cn(
                styles.list,
            )}>
                {emails
                    ?.filter((item, index) => index < ListDefaultLen)
                    .map((item, index) => {
                        return (
                            <div
                                key={`${item}_${index}`}
                                className={styles['email-item']}
                            >
                                {item}
                            </div>
                        )
                    })}


                {emails.length > ListDefaultLen && (
                    <>
                        {!showMore && (
                            <div className={'text-center'}>
                                <Iconfont
                                    onClick={() => setShowMore(true)}
                                    className={cn(styles['more'], 'icon-arrow-down')}/>
                            </div>
                        )}

                            <div className={cn(
                                styles['more-list'],
                                !showMore && styles['none']
                            )}>
                                {emails
                                    ?.filter((item, index) => index >= ListDefaultLen)
                                    .map((item, index) => {
                                        return (
                                            <div
                                                key={`${item}_${index}`}
                                                className={styles['email-item']}
                                            >
                                                {item}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                    </>
                )}

            </div>

        </div>
    );
};

export default ResultsSelected;